import { offerSummaryStatistic } from './statistic';

const serviceEndpointsV2 = {
  offerSummaryStatistic,
};

export default serviceEndpointsV2;
